export default __webpack_public_path__ + "static/media/radioButton.b5f0c58b.gif";